import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom'; 
import "./DomainPage.css";
import DashboardLayout from '../Dashboard/layout';
import { Headings } from '../RegisteredUsersList/ViewRegList';
import { Form } from 'react-bootstrap';

const AddDomainPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    status: "",
  });
  const navigate = useNavigate();
  const [validationErrors, setValidationErrors] = useState({});

 
  const validateDomain = (domain) => {
    // This regex will allow only email-like domains, e.g., @gmail.com, @yahoo.com, etc.
    const domainRegex = /^@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return domainRegex.test(domain);
  };
  

  const validateForm = () => {
    const errors = {};
  
    if (!formData.name.trim()) {
      errors.name = "Domain name is required.";
    } else {
      const domainRegex = /^@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!domainRegex.test(formData.name)) {
        errors.name = "Please add '@' before the domain name.";
      }
    }
  
    if (formData.status === "") {
      errors.status = "Status is required.";
    }
  
    return errors;
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

 
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
  
      if (errors.name === "Please enter a valid domain name.") {
        Swal.fire({
          icon: "error",
          title: "Invalid Domain",
          text: errors.name,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Validation Error",
          text: "Please fill in all required fields correctly.",
        });
      }
  
      return;
    }
  
    setValidationErrors({});
  
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/admin/domains`,
        formData,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
  
      if (res.data.status === 0) {
        Swal.fire({
          title: 'Error',
          text: 'Domain name already exists!',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      } else {
        Swal.fire({
          title: 'Success',
          text: 'New domain added successfully!',
          icon: 'success',
          confirmButtonText: 'OK',
        });
        navigate("/domains");
      }
    } catch (error) {
      console.error('Error submitting data', error);
      if (error.response) {
        Swal.fire(
          'Error',
          error.response.data.message || 'Something went wrong. Please try again.',
          'error'
        );
      } else {
        Swal.fire('Error', 'Unable to reach the server.', 'error');
      }
    }
  };

  return (
    <DashboardLayout>
      <section className="MainDivSec">

        <Headings headspan="Add" hedtext=" Domain " />

        <div className="AdduserFormDiv">

          <Form onSubmit={handleSubmit}>

            <div className="FormGroupDiv">
              <label htmlFor="name">Domain Name:</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Enter domain name (e.g., @example.com)"/>
                {validationErrors.name && (
                <small className="error">{validationErrors.name}</small>
              )}
            </div>

            <div className="FormGroupDiv">
              <label htmlFor="status">Status:</label>
              <select
                id="status"
                name="status"
                value={formData.status}
                onChange={handleInputChange}>
                <option value="">Select status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
              {validationErrors.status && (
              <small className="error">{validationErrors.status}</small>
              )}
            </div>

            <div className="SubMit">
              <button type="submit" >Add Domain</button>
            </div>


          </Form>

        </div>

      </section>
     
    </DashboardLayout>
  );
};

export default AddDomainPage;
